import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { IUser } from "src/app/shared/interfaces";
import { SharedService } from "../../shared/shared.service";
import { UserService } from "../../_services";

@Component({
  selector: "sms-authentication",
  templateUrl: "./sms-authentication.component.html",
})
export class SmsAuthenticationComponent implements OnInit {
  @Output() back = new EventEmitter<any>();
  @Output() continue = new EventEmitter<any>();
  public mobileNumbers: Array<any> = [];
  private selectedNumber: any;

  constructor(
    public sharedService: SharedService,
    public userService: UserService
  ) {}

  ngOnInit() {
    this.getContactDetails();
  }

  public onBack() {
    this.back.emit();
  }

  public onContinue() {
    this.continue.emit(this.selectedNumber);
  }

  public getContactDetails() {
    this.userService
      .getUserById(
        this.sharedService.currentOrganisationId.value,
        this.sharedService.loggedUserId.value
      )
      .subscribe((resp) => {
        const user: IUser = resp.body;
        const userMobileNo: Array<any> = user.contactDetails.filter((el) => el.type == "MOBILE").map(function (item) {
          return { label: item.communicationType[0], value: item.value };
        });
        const personMobileNo: Array<any> = user.person.contactDetails.filter((el) => el.type == "MOBILE").map(function (item) {
          return { label: item.communicationType[0], value: item.value };
        });

        this.mobileNumbers = userMobileNo;
        personMobileNo.forEach((el) => {
          if (this.mobileNumbers.findIndex((item) => item.value == el.value) == -1) {
            this.mobileNumbers.push(el);
          }
        });
        if (this.mobileNumbers.length > 0) {
          this.selectedNumber = this.mobileNumbers[0].value;
        }
      });
  }

  public numberChanged(event: Event) {
    this.selectedNumber = (event.target as HTMLInputElement).value;
  }
}
